import { useState } from 'react';

interface IUsePostponeDealDialogProps {
    isOpen?: boolean;
    onOpenChange?: (open: boolean) => void;
    onClose: () => void;
}

export const usePostponeDealDialog = ({
    isOpen,
    onOpenChange,
    onClose,
}: IUsePostponeDealDialogProps) => {
    const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
    const isDialogOpen = isOpen ?? uncontrolledOpen;

    const handleDialogOpenChange = (nextOpen: boolean) => {
        setUncontrolledOpen(nextOpen);
        onOpenChange?.(nextOpen);

        if (!nextOpen) {
            onClose();
        }
    };

    return {
        isDialogOpen,
        handleDialogOpenChange,
    };
};
